import React from 'react'
import WaveSvg from 'src/images/wave.svg'

const Wave = ({ flip, scale, className, style ={} }) => {
    const classes = `w-full -mt-px -mb-px ${flip ? 'rotate-180' : ''} ${scale ? 'scale-x-[-1]' : ''} ${className ? className : ''}`
    return (
        <WaveSvg className={classes} style={style}/>
    )
}

export default Wave